import { useState, useEffect } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Select,
  MenuItem,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  IconButton,
} from "@mui/material";
import { alpha } from "@mui/material";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  P2PWEBSERVICE,
  showToast,
  WEBSERVICE,
} from "../../CoreDataService";
import axios from "axios";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import P2PNavbar from "./P2PNavbar";
import { useSelector } from "react-redux";
import DownloadIcon from "@mui/icons-material/Download";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";

function P2PMyOrders() {
  const navigate = useNavigate();
  const { btncolor } = useSelector((state) => state);

  const [loading, setLoading] = useState(true);
  const [themeColor, setThemeColor] = useState("Dark");
  const [activeTab, setActiveTab] = useState(0);

  const [allOrders, setAllOrders] = useState([]);
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [feedbackType, setFeedbackType] = useState(1);
  const [feedbackText, setFeedbackText] = useState("");
  const [processingFilter, setProcessingFilter] = useState("all");
  const [allOrdersFilter, setAllOrdersFilter] = useState("allOrders");
  const [coin, setCoin] = useState("");
  const [orderType, setOrderType] = useState("");
  const [fromDate, setFromDate] = useState(dayjs("1970-01-01"));
  const [toDate, setToDate] = useState(dayjs());
  const [allCurrencies, setAllCurrencies] = useState([]);
  const [selectedFiatCurrency, setSelectedFiatCurrency] = useState("USDT");
  const [counterCurrency, setCounterCurrency] = useState([]);

  const [allOrdersFromDate, setAllOrdersFromDate] = useState(dayjs());
  const [allOrdersToDate, setAllOrdersToDate] = useState(dayjs());

  const [orderStatus, setOrderStatus] = useState(""); // or default it to 0
  const [filteredAllOrders, setFilteredAllOrders] = useState([]);

  // For Processing Orders
  const [processingOrders, setProcessingOrders] = useState([]);
  const [processingOrdersLoading, setProcessingOrdersLoading] = useState(false);

  // For Profit and Loss
  const [pnlOrders, setPnlOrders] = useState([]);
  const [cumulativePnl, setCumulativePnl] = useState(0);
  const [pnlLoading, setPnlLoading] = useState(false);

  // Filters for PnL
  const [pnlCrypto, setPnlCrypto] = useState("");
  const [pnlOrderType, setPnlOrderType] = useState("");
  const [pnlFromDate, setPnlFromDate] = useState(dayjs("1970-01-01"));
  const [pnlToDate, setPnlToDate] = useState(dayjs());

  const [lastOrderId, setLastOrderId] = useState("");
  const [counterPartyUuid, setCounterPartyUuid] = useState("");

  const handleResetFilters = () => {
    setCoin("");
    setOrderType("");
  };

  const filteredProcessingOrders = processingOrders.filter((order) => {
    if (processingFilter === "all") return true;
    if (processingFilter === "unpaid")
      return order.status.toLowerCase() === "unpaid";
    if (processingFilter === "paid")
      return order.status.toLowerCase() === "paid";
    if (processingFilter === "appealInProgress")
      return order.status.toLowerCase() === "appeal in progress";
    return true;
  });

  // Dummy data for demonstration
  useEffect(() => {
    getCurrencyByAd();
    getBasecurrencyList();
    getAllOrders();
    getProcessingOrders();
    getProfitAndLossStatement();
  }, [orderStatus]);

  const formatDate = (date) => {
    if (!date) return "";
    const year = date.year();
    let month = (date.month() + 1).toString().padStart(2, "0");
    let day = date.date().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getAllOrders = async () => {
    try {
      setLoading(true);

      const coinModified = coin || "All coins";
      const orderTypeModified = orderType || "All";

      const requestBody = {
        uuid: localStorage.getItem("uuid"),
        coin: coinModified,
        orderType: orderTypeModified,
        fromDate: formatDate(fromDate),
        toDate: formatDate(toDate),
        isAdmin: 0,
        orderStatus: orderStatus || 0,
      };

      const response = await fetch(`${P2PWEBSERVICE}/getAllOrders`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${localStorage.getItem("access_token")}`,
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      if (data.error?.error_data === 0) {
        if (data.orderDetails?.length > 0) {
          const orders = data.orderDetails.map((order) => ({
            uuid: order.uuid,
            orderType: order.orderType,
            coin: order.coin,
            orderDate: order.orderDate,
            fiatAmount: order.fiatAmount,
            price: order.price,
            cryptoAmount: order.cryptoAmount,
            counterParty: order.counterParty,
            status: order.status,
            operation: order.operation,
            fromDate: order.fromDate,
            toDate: order.toDate,
            adId: order.adId,
            orderId: order.orderId,
            fiatPrice: order.fiatPrice,
            totalAmount: order.totalAmount,
            crypto: order.crypto,
            fiat: order.fiat,
            paymentMethod: order.paymentMethod,
            nickName: order.nickName,
            adType: order.adType,
            counterPartyUuid: order.counterPartyUuid,
            totalFiatPrice: parseFloat(order.totalFiatPrice.toFixed(2)),
          }));

          setFilteredAllOrders(orders);
        } else {
          setFilteredAllOrders([]);
        }
      } else {
        alert(data.error?.error_msg || "Error fetching orders");
      }
    } catch (error) {
      console.error("Error fetching all orders:", error);
    } finally {
      setLoading(false);
    }
  };

  const getProcessingOrders = async () => {
    try {
      setProcessingOrdersLoading(true);

      const requestBody = {
        uuid: localStorage.getItem("uuid"),
        orderStatus: orderStatus, // Assuming 1 = processing status, you can make it dynamic if needed
        offset: 1,
        limit: 100,
      };

      const response = await fetch(`${P2PWEBSERVICE}/getProcessingOrders`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${localStorage.getItem("access_token")}`,
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (data.error?.error_data === 0) {
        console.log("data.orderDetails", data.orderDetails);

        if (data.orderDetails?.length > 0) {
          const orders = data.orderDetails.map((order) => ({
            uuid: order.uuid,
            orderType: order.orderType,
            coin: order.coin,
            orderDate: order.orderDate,
            fiatAmount: order.fiatAmount,
            price: order.price,
            cryptoAmount: order.cryptoAmount,
            counterParty: order.counterParty,
            status: order.status,
            operation: order.operation,
            fromDate: order.fromDate,
            toDate: order.toDate,
            offset: order.offset,
            limit: order.limit,
            orderStatus: order.orderStatus,
            isAdmin: order.isAdmin,
            adId: order.adId,
            orderId: order.orderId,
            fiatPrice: order.fiatPrice,
            totalAmount: order.totalAmount,
            crypto: order.crypto,
            fiat: order.fiat,
            paymentMethod: order.paymentMethod,
            nickName: order.nickName,
            adType: order.adType,
            counterPartyUuid: order.counterPartyUuid,
            totalFiatPrice: parseFloat(order.totalFiatPrice.toFixed(2)),
          }));
          setProcessingOrders(orders);
        } else {
          setProcessingOrders([]);
        }
      } else {
        showToast(
          "error",
          data.error?.error_msg || "Error fetching processing orders"
        );
      }
    } catch (error) {
      console.error("Error fetching processing orders:", error);
    } finally {
      setProcessingOrdersLoading(false);
    }
  };

  const getProfitAndLossStatement = async () => {
    try {
      setPnlLoading(true);

      const cryptoModified = pnlCrypto || "All coins";
      const orderTypeModified = pnlOrderType || "All";

      const requestBody = {
        uuid: localStorage.getItem("uuid"),
        crypto: cryptoModified,
        orderType: orderTypeModified,
        toDate: formatDate(pnlToDate),
        fromDate: formatDate(pnlFromDate),
      };

      const response = await fetch(
        `${P2PWEBSERVICE}/getProfitAndLossStatement`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();

      if (data.profitNLossRespones?.length > 0) {
        const cryptoList = [
          ...new Set(data.profitNLossRespones.map((order) => order.crypto)),
        ];

        const pnlDetails = cryptoList.map((crypto) => {
          const buyOrder = data.profitNLossRespones.find(
            (order) => order.crypto === crypto && order.orderType === "BUY"
          );
          const sellOrder = data.profitNLossRespones.find(
            (order) => order.crypto === crypto && order.orderType === "SELL"
          );

          return {
            crypto,
            orderTypeBuy: buyOrder?.orderType,
            fiatBuy: buyOrder?.fiat,
            ordersBuy: buyOrder?.orders,
            avgPriceBuy: buyOrder?.avgPrice,
            totalCryptoAmountBuy: buyOrder?.totalCryptoAmount,
            totalfiatAmountBuy: buyOrder?.totalfiatAmount,
            totalTxnFeeBuy: buyOrder?.totalTxnFee,
            orderTypeSell: sellOrder?.orderType,
            fiatSell: sellOrder?.fiat,
            ordersSell: sellOrder?.orders,
            avgPriceSell: sellOrder?.avgPrice,
            totalCryptoAmountSell: sellOrder?.totalCryptoAmount,
            totalfiatAmountSell: sellOrder?.totalfiatAmount,
            totalTxnFeeSell: sellOrder?.totalTxnFee,
            pnl: buyOrder?.pnl,
          };
        });

        setPnlOrders(pnlDetails);
      } else {
        setPnlOrders([]);
      }
      setCumulativePnl(data.cumulativePNL || 0);
    } catch (error) {
      showToast("error", "Error fetching PnL statement:", error);
    } finally {
      setPnlLoading(false);
    }
  };

  const getCurrencyByAd = async () => {
    try {
      const response = await axios.get(
        `${WEBSERVICE}crypto/banking/p2p/getCurrencyByAd/${localStorage.getItem(
          "BROKERID"
        )}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const assetDetails = response.data.assetDetails || [];

      setAllCurrencies(assetDetails);
      setSelectedFiatCurrency(assetDetails[0]?.currencyCode || "");
    } catch (error) {
      console.error("Error fetching currency data:", error);
    }
  };

  // Function to fetch the base currency list
  const getBasecurrencyList = async () => {
    const brokerId = localStorage.getItem("BROKERID");
    const accessToken = localStorage.getItem("access_token");

    try {
      const response = await axios.get(
        `${WEBSERVICE}home/getAllCurrency/${brokerId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const result = response.data;
      setCounterCurrency(result.currencyList); // Store the currency list in state
    } catch (error) {
      // Handle errors
      if (error.response) {
        showToast("error", `${error.response.status}`);
        console.error(
          "Error fetching base currency list:",
          error.response.data
        );
      } else {
        showToast("error", "An unexpected error occurred");
        console.error("Unexpected error:", error);
      }
    }
  };

  const goToOrderDetails = (order) => {
    localStorage.setItem("previousAdId", order.adId);
    localStorage.setItem("previousOrderId", order.operation);
    localStorage.setItem("orderCreationTime", order.orderDate);
    localStorage.setItem("counterPartyUuid", order.counterPartyUuid);
    localStorage.setItem("chatUserName", order.counterParty);
    localStorage.setItem("orderfiat", order.fiat);
    localStorage.setItem("orderCrypto", order.coin);

    if (order.orderType?.toLowerCase() === "buy") {
      // Receive Quantity
      localStorage.setItem("previousPageBuyAmount", order.cryptoAmount);
      // Price
      localStorage.setItem("previousPageBuyprice", order.price);
      // Amount
      localStorage.setItem("previousPageBuyTotalAmount", order.totalFiatPrice);

      navigate("/p2p/order-details");
    } else {
      // Receive Quantity
      localStorage.setItem("previousPageBuyprice", order.cryptoAmount);
      // Price
      localStorage.setItem("previousPageBuyAmount", order.price);
      // Amount
      localStorage.setItem("previousPageBuyTotalAmount", order.totalFiatPrice);

      navigate("/p2p/sell-order-details");
    }
  };

  const goToAllOrderDetails = (order) => {
    localStorage.setItem("previousAdId", order.adId);
    localStorage.setItem("previousOrderId", order.operation);
    localStorage.setItem("orderCreationTime", order.orderDate);
    localStorage.setItem("counterPartyUuid", order.counterPartyUuid);
    localStorage.setItem("chatUserName", order.counterParty);
    localStorage.setItem("orderfiat", order.fiat);
    localStorage.setItem("orderCrypto", order.coin);

    if (order.orderType?.toLowerCase() === "buy") {
      // Receive Quantity
      localStorage.setItem("previousPageBuyAmount", order.cryptoAmount);
      // Price
      localStorage.setItem("previousPageBuyprice", order.price);
      // Amount
      localStorage.setItem("previousPageBuyTotalAmount", order.totalFiatPrice);

      navigate("/p2p/order-details");
    } else {
      // Receive Quantity
      localStorage.setItem("previousPageBuyprice", order.cryptoAmount);
      // Price
      localStorage.setItem("previousPageBuyAmount", order.price);
      // Amount
      localStorage.setItem("previousPageBuyTotalAmount", order.totalFiatPrice);

      navigate("/p2p/sell-order-details");
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const openFeedbackModal = (orderId, uuid) => {
    setLastOrderId(orderId);
    setCounterPartyUuid(uuid);
    setFeedbackModalOpen(true);
  };

  const closeFeedbackModal = () => {
    setFeedbackModalOpen(false);
  };

  const downloadOrderList = ({
    type = "PNL", // 'PNL' or 'ALL'
  }) => {
    const isEmpty = (val) => val === undefined || val === null || val === "";

    const coinModified = !isEmpty(coin) ? coin : "All coins";
    const orderTypeModified = !isEmpty(orderType) ? orderType : "All";

    const jsonObj = {
      uuid: localStorage.getItem("uuid"),
      coin: coinModified,
      orderType: orderTypeModified,
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
    };

    fetch(`${P2PWEBSERVICE}/downloadOrderList`, {
      method: "POST",
      headers: {
        authorization: "BEARER " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(jsonObj),
    })
      .then((resp) => resp.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = type === "PNL" ? "pnl-orders.xlsx" : "all-orders.xlsx";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        alert("Failed to download the file", "danger");
      });
  };

  const giveFeedback = async () => {
    try {
      const jsonObj = {
        uuid: localStorage.getItem("uuid"),
        counterPertyUuid: counterPartyUuid,
        orderId: lastOrderId,
        feedbackMessage: feedbackText,
        feedbackStatus: feedbackType,
      };

      const response = await axios.post(
        `${P2PWEBSERVICE}/addFeedback`,
        jsonObj,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.error_data === 0) {
        showToast("success", response.data.error_msg);
      } else {
        showToast("error", response.data.error_msg);
      }

      setFeedbackModalOpen(false);
    } catch (error) {
      console.error("Feedback submission failed:", error);
      showToast("error", "Something went wrong while submitting feedback");

      setFeedbackModalOpen(false);
    }
  };

  // ─── Style constants ───────────────────────────────────────────────────────
  const color = btncolor || "#1976d2";

  const pageWrapper = {
    px: { xs: 2, md: 4 },
    py: { xs: 2, md: 3 },
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
    minHeight: "calc(100vh - 64px)",
  };

  const heroBanner = {
    borderRadius: "18px",
    px: { xs: 3, md: 4 },
    py: { xs: 3, md: 3.5 },
    mb: 3,
    display: "flex",
    alignItems: "center",
    gap: 2.5,
  };

  const mainCard = {
    backgroundColor: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid rgba(125,125,125,0.15)",
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
    overflow: "hidden",
    mb: 3,
  };

  const tabsWrap = {
    borderBottom: "1px solid rgba(125,125,125,0.15)",
    backgroundColor: "var(--body-color-less2)",
    px: { xs: 1, md: 2 },
  };

  const filterCard = {
    p: { xs: 2, md: 2.5 },
    mb: 3,
    backgroundColor: "var(--body-color-less2)",
    borderRadius: "12px",
    border: "1px solid rgba(125,125,125,0.12)",
  };

  const fieldWrap = { display: "flex", flexDirection: "column", gap: 0.75 };

  const fieldLabel = {
    fontSize: "0.78rem",
    fontWeight: 600,
    color: "var(--text-color)",
    opacity: 0.6,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  };

  const modernFieldStyle = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "var(--body-color-less)",
      borderRadius: "8px",
      "& fieldset": { borderColor: "rgba(125,125,125,0.2)" },
      "&:hover fieldset": { borderColor: "rgba(125,125,125,0.4)" },
      "&.Mui-focused fieldset": { borderColor: color },
    },
    "& .MuiInputBase-input": { color: "var(--text-color)", fontSize: "0.88rem" },
    "& .MuiInputLabel-root": { display: "none" },
    "& .MuiSelect-icon": { color: "var(--text-color)" },
  };

  const filterBtn = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
    px: 2,
    py: 1,
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "0.82rem",
    fontWeight: 600,
    backgroundColor: alpha(color, 0.12),
    color: color,
    border: `1px solid ${alpha(color, 0.25)}`,
    "&:hover": { backgroundColor: alpha(color, 0.2) },
  };

  const modernTableContainer = {
    borderRadius: "12px",
    border: "1px solid rgba(125,125,125,0.15)",
    overflow: "hidden",
    backgroundColor: "var(--body-color-less)",
  };

  const headCellSx = {
    fontSize: "0.72rem",
    fontWeight: 700,
    color: "var(--text-color)",
    opacity: 0.6,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    py: 1.5,
    px: 2,
    borderBottom: "1px solid rgba(125,125,125,0.15)",
    whiteSpace: "nowrap",
    backgroundColor: "var(--body-color-less2)",
  };

  const bodyCellSx = {
    py: 1.5,
    px: 2,
    fontSize: "0.85rem",
    color: "var(--text-color)",
    borderBottom: "1px solid rgba(125,125,125,0.08)",
  };

  const chipBase = {
    px: 2,
    py: 0.75,
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "0.82rem",
    fontWeight: 600,
    userSelect: "none",
  };

  const chipInactive = {
    ...chipBase,
    border: "1px solid rgba(125,125,125,0.2)",
    color: "var(--text-color)",
    opacity: 0.7,
    backgroundColor: "transparent",
  };

  const chipActive = {
    ...chipBase,
    backgroundColor: alpha(color, 0.12),
    border: `1px solid ${alpha(color, 0.3)}`,
    color: color,
    opacity: 1,
  };

  const dialogPaper = {
    borderRadius: "16px",
    backgroundColor: "var(--popupbody-color)",
    color: "var(--text-color)",
  };

  const dialogTitleStyle = {
    fontWeight: 700,
    py: 2.25,
    color: "var(--text-color)",
    backgroundColor: "var(--popupheader-color)",
    position: "relative",
  };

  const dialogCloseBtn = {
    position: "absolute",
    right: 12,
    top: "50%",
    transform: "translateY(-50%)",
    color: "var(--text-color)",
    opacity: 0.6,
  };

  // ─── Loading state ─────────────────────────────────────────────────────────
  if (loading) {
    return (
      <Box
        sx={{
          height: "100vh",
          backgroundColor: "var(--body-color)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress sx={{ color: color }} />
      </Box>
    );
  }

  // ─── Render ────────────────────────────────────────────────────────────────
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={pageWrapper}>
        {/* Hero Banner */}
        <Box
          sx={{
            ...heroBanner,
            background: `linear-gradient(135deg, ${alpha(color, 0.95)} 0%, ${alpha(color, 0.75)} 100%)`,
          }}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "14px",
              backgroundColor: "rgba(255,255,255,0.18)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <AssignmentOutlinedIcon sx={{ fontSize: 28, color: "#fff" }} />
          </Box>
          <Box>
            <Typography
              sx={{ fontSize: "1.7rem", fontWeight: 700, color: "#fff", lineHeight: 1.2 }}
            >
              My P2P Orders
            </Typography>
            <Typography sx={{ fontSize: "0.92rem", color: "rgba(255,255,255,0.88)", mt: 0.5 }}>
              Track and manage your P2P trading orders
            </Typography>
          </Box>
        </Box>

        {/* Main Card */}
        <Box sx={mainCard}>
          <P2PNavbar />

          {/* Tabs */}
          <Box sx={tabsWrap}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              textColor="inherit"
              TabIndicatorProps={{ style: { backgroundColor: color } }}
              sx={{
                "& .MuiTab-root": { color: "var(--text-color)", fontWeight: 600, fontSize: "0.88rem" },
                "& .Mui-selected": { color: color },
              }}
            >
              <Tab label="Processing" />
              <Tab label="All Orders" />
              <Tab label="Profit & Loss Statement" />
            </Tabs>
          </Box>

          <Box sx={{ p: { xs: 2, md: 3 } }}>
            {/* ========== Processing Tab ========== */}
            {activeTab === 0 && (
              <Box>
                {/* Filter Chips */}
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2.5 }}>
                  {[
                    { key: "all", label: "All", status: 0 },
                    { key: "unpaid", label: "Unpaid", status: 1 },
                    { key: "paid", label: "Paid", status: 2 },
                    { key: "appealInProgress", label: "Appeal in Progress", status: 3 },
                  ].map((item) => (
                    <Box
                      key={item.key}
                      sx={processingFilter === item.key ? chipActive : chipInactive}
                      onClick={() => {
                        setProcessingFilter(item.key);
                        setOrderStatus(item.status);
                      }}
                    >
                      {item.label}
                    </Box>
                  ))}
                </Box>

                {filteredProcessingOrders.length === 0 ? (
                  <Box sx={{ py: 8, textAlign: "center" }}>
                    <InboxOutlinedIcon
                      sx={{ fontSize: 48, color: "var(--text-color)", opacity: 0.2, mb: 1.5 }}
                    />
                    <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.5 }}>
                      No orders found
                    </Typography>
                  </Box>
                ) : (
                  <TableContainer sx={modernTableContainer}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          {["Type/Coin", "Order Amount", "Price", "Crypto Amount", "Counter Party", "Status", "Operation"].map(
                            (col) => (
                              <TableCell key={col} sx={headCellSx}>
                                {col}
                              </TableCell>
                            )
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredProcessingOrders.map((order, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:hover": { backgroundColor: "rgba(125,125,125,0.04)" },
                              borderBottom: "1px solid rgba(125,125,125,0.08)",
                            }}
                          >
                            <TableCell sx={bodyCellSx}>
                              <Typography
                                sx={{
                                  fontSize: "0.82rem",
                                  fontWeight: 700,
                                  color: order.orderType === "BUY" ? "#22c55e" : "#ef4444",
                                }}
                              >
                                {order.orderType}
                              </Typography>
                              <Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}>
                                {order.coin}
                              </Typography>
                            </TableCell>
                            <TableCell sx={bodyCellSx}>{order.totalFiatPrice}</TableCell>
                            <TableCell sx={bodyCellSx}>{order.price}</TableCell>
                            <TableCell sx={bodyCellSx}>{order.cryptoAmount}</TableCell>
                            <TableCell sx={bodyCellSx}>{order.counterParty}</TableCell>
                            <TableCell sx={bodyCellSx}>{order.status}</TableCell>
                            <TableCell sx={bodyCellSx}>
                              <ContainedButton
                                variant="contained"
                                size="small"
                                onClick={() => goToOrderDetails(order)}
                              >
                                Go to order details
                              </ContainedButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Box>
            )}

            {/* ========== All Orders Tab ========== */}
            {activeTab === 1 && (
              <Box>
                {/* Filter Chips */}
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2.5 }}>
                  {[
                    { key: "allOrders", label: "All", status: 0 },
                    { key: "completed", label: "Completed", status: 1 },
                    { key: "cancelled", label: "Cancelled", status: 2 },
                  ].map((item) => (
                    <Box
                      key={item.key}
                      sx={allOrdersFilter === item.key ? chipActive : chipInactive}
                      onClick={() => {
                        setAllOrdersFilter(item.key);
                        setOrderStatus(item.status);
                      }}
                    >
                      {item.label}
                    </Box>
                  ))}
                </Box>

                {/* Filter Card */}
                <Box sx={filterCard}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(4, 1fr) auto auto" },
                      gap: 1.5,
                      alignItems: "end",
                    }}
                  >
                    {/* Coin */}
                    <Box sx={fieldWrap}>
                      <Typography sx={fieldLabel}>Coin</Typography>
                      <Select
                        value={coin}
                        onChange={(e) => setCoin(e.target.value)}
                        size="small"
                        displayEmpty
                        sx={modernFieldStyle}
                      >
                        <MenuItem value="">All Coins</MenuItem>
                        {allCurrencies.map((cur, index) => (
                          <MenuItem key={index} value={cur.currencyCode}>
                            {cur.currencyCode}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>

                    {/* Order Type */}
                    <Box sx={fieldWrap}>
                      <Typography sx={fieldLabel}>Order Type</Typography>
                      <Select
                        value={orderType}
                        onChange={(e) => setOrderType(e.target.value)}
                        size="small"
                        displayEmpty
                        sx={modernFieldStyle}
                      >
                        <MenuItem value="">All</MenuItem>
                        <MenuItem value="BUY">BUY</MenuItem>
                        <MenuItem value="SELL">SELL</MenuItem>
                      </Select>
                    </Box>

                    {/* From Date */}
                    <Box sx={fieldWrap}>
                      <Typography sx={fieldLabel}>From Date</Typography>
                      <DatePicker
                        value={fromDate}
                        onChange={(newValue) => setFromDate(newValue)}
                        slotProps={{ textField: { sx: modernFieldStyle, size: "small" } }}
                      />
                    </Box>

                    {/* To Date */}
                    <Box sx={fieldWrap}>
                      <Typography sx={fieldLabel}>To Date</Typography>
                      <DatePicker
                        value={toDate}
                        onChange={(newValue) => setToDate(newValue)}
                        slotProps={{ textField: { sx: modernFieldStyle, size: "small" } }}
                      />
                    </Box>

                    {/* Reset */}
                    <Box sx={filterBtn} onClick={handleResetFilters}>
                      <RestartAltIcon sx={{ fontSize: 16 }} />
                      Reset
                    </Box>

                    {/* Download */}
                    <Box sx={filterBtn} onClick={() => downloadOrderList({ type: "ALL" })}>
                      <DownloadIcon sx={{ fontSize: 16 }} />
                      Download
                    </Box>
                  </Box>
                </Box>

                {/* All Orders Table */}
                {filteredAllOrders.length === 0 ? (
                  <Box sx={{ py: 8, textAlign: "center" }}>
                    <InboxOutlinedIcon
                      sx={{ fontSize: 48, color: "var(--text-color)", opacity: 0.2, mb: 1.5 }}
                    />
                    <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.5 }}>
                      No orders found
                    </Typography>
                  </Box>
                ) : (
                  <TableContainer sx={modernTableContainer}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          {["Type/Coin", "Order Amount", "Price", "Crypto Amount", "Counter Party", "Status", "Operation"].map(
                            (col) => (
                              <TableCell key={col} sx={headCellSx}>
                                {col}
                              </TableCell>
                            )
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredAllOrders.map((order, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:hover": { backgroundColor: "rgba(125,125,125,0.04)" },
                              borderBottom: "1px solid rgba(125,125,125,0.08)",
                            }}
                          >
                            <TableCell sx={bodyCellSx}>
                              <Typography
                                sx={{
                                  fontSize: "0.82rem",
                                  fontWeight: 700,
                                  color: order.orderType === "BUY" ? "#22c55e" : "#ef4444",
                                }}
                              >
                                {order.orderType}
                              </Typography>
                              <Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}>
                                {order.coin}
                              </Typography>
                            </TableCell>
                            <TableCell sx={bodyCellSx}>
                              {order.totalFiatPrice} {order.fiat}
                            </TableCell>
                            <TableCell sx={bodyCellSx}>
                              {order.price} {order.fiat}
                            </TableCell>
                            <TableCell sx={bodyCellSx}>
                              {order.cryptoAmount} {order.coin}
                            </TableCell>
                            <TableCell sx={bodyCellSx}>{order.counterParty}</TableCell>
                            <TableCell sx={bodyCellSx}>{order.status}</TableCell>
                            <TableCell sx={bodyCellSx}>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: { xs: "column", sm: "row" },
                                  gap: { xs: 0.5, sm: 1 },
                                  alignItems: { xs: "flex-start", sm: "center" },
                                }}
                              >
                                <OutlinedButton
                                  variant="outlined"
                                  size="small"
                                  fullWidth={false}
                                  sx={{ minWidth: "auto", fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                                  onClick={() =>
                                    openFeedbackModal(order.operation, order.counterPartyUuid)
                                  }
                                >
                                  Feedback
                                </OutlinedButton>
                                <OutlinedButton
                                  variant="outlined"
                                  size="small"
                                  fullWidth={false}
                                  sx={{ minWidth: "auto" }}
                                  onClick={() => goToAllOrderDetails(order)}
                                >
                                  Go to order Details
                                </OutlinedButton>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Box>
            )}

            {/* ========== PNL Tab ========== */}
            {activeTab === 2 && (
              <Box>
                {/* Filter Card */}
                <Box sx={filterCard}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(4, 1fr) auto auto" },
                      gap: 1.5,
                      alignItems: "end",
                    }}
                  >
                    {/* Coin */}
                    <Box sx={fieldWrap}>
                      <Typography sx={fieldLabel}>Coin</Typography>
                      <Select
                        value={coin}
                        onChange={(e) => setCoin(e.target.value)}
                        size="small"
                        displayEmpty
                        sx={modernFieldStyle}
                      >
                        <MenuItem value="">All Coins</MenuItem>
                        {allCurrencies.map((cur, index) => (
                          <MenuItem key={index} value={cur.currencyCode}>
                            {cur.currencyCode}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>

                    {/* Order Type */}
                    <Box sx={fieldWrap}>
                      <Typography sx={fieldLabel}>Order Type</Typography>
                      <Select
                        value={orderType}
                        onChange={(e) => setOrderType(e.target.value)}
                        size="small"
                        displayEmpty
                        sx={modernFieldStyle}
                      >
                        <MenuItem value="">All</MenuItem>
                        <MenuItem value="BUY">BUY</MenuItem>
                        <MenuItem value="SELL">SELL</MenuItem>
                      </Select>
                    </Box>

                    {/* From Date */}
                    <Box sx={fieldWrap}>
                      <Typography sx={fieldLabel}>From Date</Typography>
                      <DatePicker
                        value={fromDate}
                        onChange={(newValue) => setFromDate(newValue)}
                        slotProps={{ textField: { sx: modernFieldStyle, size: "small" } }}
                      />
                    </Box>

                    {/* To Date */}
                    <Box sx={fieldWrap}>
                      <Typography sx={fieldLabel}>To Date</Typography>
                      <DatePicker
                        value={toDate}
                        onChange={(newValue) => setToDate(newValue)}
                        slotProps={{ textField: { sx: modernFieldStyle, size: "small" } }}
                      />
                    </Box>

                    {/* Reset */}
                    <Box sx={filterBtn} onClick={handleResetFilters}>
                      <RestartAltIcon sx={{ fontSize: 16 }} />
                      Reset
                    </Box>

                    {/* Download */}
                    <Box sx={filterBtn} onClick={() => downloadOrderList({ type: "PNL" })}>
                      <DownloadIcon sx={{ fontSize: 16 }} />
                      Download
                    </Box>
                  </Box>
                </Box>

                {pnlOrders.length === 0 ? (
                  <Box sx={{ py: 8, textAlign: "center" }}>
                    <InboxOutlinedIcon
                      sx={{ fontSize: 48, color: "var(--text-color)", opacity: 0.2, mb: 1.5 }}
                    />
                    <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.5 }}>
                      No orders found
                    </Typography>
                  </Box>
                ) : (
                  <TableContainer sx={modernTableContainer}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          {["Coin", "Type", "Orders", "Avg Price", "Total Crypto", "Total Fiat", "Txn Fee", "Profit/Loss"].map(
                            (col) => (
                              <TableCell key={col} sx={headCellSx}>
                                {col}
                              </TableCell>
                            )
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {pnlOrders.map((order, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:hover": { backgroundColor: "rgba(125,125,125,0.04)" },
                              borderBottom: "1px solid rgba(125,125,125,0.08)",
                            }}
                          >
                            <TableCell sx={bodyCellSx}>{order.crypto}</TableCell>
                            <TableCell sx={bodyCellSx}>
                              <Typography sx={{ fontSize: "0.82rem", color: "#22c55e", fontWeight: 600 }}>
                                BUY: {order.ordersBuy}
                              </Typography>
                              <Typography sx={{ fontSize: "0.82rem", color: "#ef4444", fontWeight: 600 }}>
                                SELL: {order.ordersSell}
                              </Typography>
                            </TableCell>
                            <TableCell sx={bodyCellSx}>
                              {order.ordersBuy + order.ordersSell}
                            </TableCell>
                            <TableCell sx={bodyCellSx}>
                              <Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}>
                                BUY: {order.avgPriceBuy} {order.fiatBuy}
                              </Typography>
                              <Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}>
                                SELL: {order.avgPriceSell} {order.fiatSell}
                              </Typography>
                            </TableCell>
                            <TableCell sx={bodyCellSx}>
                              <Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}>
                                {order.totalCryptoAmountBuy} {order.crypto}
                              </Typography>
                              <Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}>
                                {order.totalCryptoAmountSell} {order.crypto}
                              </Typography>
                            </TableCell>
                            <TableCell sx={bodyCellSx}>
                              <Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}>
                                {order.totalfiatAmountSell} {order.fiatBuy}
                              </Typography>
                              <Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}>
                                {order.totalfiatAmountSell} {order.fiatBuy}
                              </Typography>
                            </TableCell>
                            <TableCell sx={bodyCellSx}>
                              <Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}>
                                {order.totalTxnFeeBuy} {order.crypto}
                              </Typography>
                              <Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}>
                                ≈ {order.totalTxnFeeSell} {order.fiatSell}
                              </Typography>
                            </TableCell>
                            <TableCell sx={bodyCellSx}>{order.pnl}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Box>
            )}
          </Box>
        </Box>

        {/* Feedback Dialog */}
        <Dialog
          open={feedbackModalOpen}
          onClose={closeFeedbackModal}
          PaperProps={{ sx: dialogPaper }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={dialogTitleStyle}>
            Add Feedback
            <IconButton sx={dialogCloseBtn} onClick={closeFeedbackModal} size="small">
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: 2.5, pb: 1 }}>
            <Box component="form" sx={{ mt: 1, display: "flex", flexDirection: "column", gap: 2 }}>
              <Box sx={fieldWrap}>
                <Typography sx={fieldLabel}>Feedback Type</Typography>
                <Select
                  fullWidth
                  value={feedbackType}
                  onChange={(e) => setFeedbackType(e.target.value)}
                  size="small"
                  sx={modernFieldStyle}
                >
                  <MenuItem value={1}>Positive</MenuItem>
                  <MenuItem value={0}>Negative</MenuItem>
                </Select>
              </Box>
              <Box sx={fieldWrap}>
                <Typography sx={fieldLabel}>Message</Typography>
                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  placeholder="Enter feedback"
                  value={feedbackText}
                  onChange={(e) => setFeedbackText(e.target.value)}
                  size="small"
                  sx={modernFieldStyle}
                />
              </Box>
            </Box>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
            <OutlinedButton variant="outlined" onClick={closeFeedbackModal}>
              Cancel
            </OutlinedButton>
            <ContainedButton
              variant="contained"
              onClick={() => giveFeedback()}
              disabled={!feedbackText}
            >
              Submit
            </ContainedButton>
          </DialogActions>
        </Dialog>
      </Box>
    </LocalizationProvider>
  );
}

export default P2PMyOrders;
